import type { ReactNode } from 'react';
import { type ClavePermiso, puede } from '@plataforma/permisos';
import { useSesion } from '@plataforma/web/sesion';

/** ¿El usuario tiene el permiso? Usa la misma tabla que el API (`@plataforma/permisos`). */
export function usePuede(): (clave: ClavePermiso) => boolean {
  const { usuario } = useSesion();
  const roles = usuario?.roles ?? [];
  return (clave) => puede(roles, clave);
}

/** Muestra la pantalla solo si el rol la incluye; si no, lo explica en lugar de fallar con 403. */
export function Requiere({ permiso, children }: { permiso: ClavePermiso; children: ReactNode }) {
  const permitido = usePuede();
  if (permitido(permiso)) return children;
  return (
    <div className="entrada" style={{ margin: '40px auto' }}>
      <h1>Tu rol no incluye esta pantalla</h1>
      <p className="subtitulo">Si la necesitas, pide al dueño del lotero que te cambie el rol.</p>
    </div>
  );
}
